import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';
import {
  BillingReadinessDetail,
  BillingReadinessResponse,
  BillingReadinessWindow,
} from '@chiroup/core/types/BillingReadiness.type';

const billingReadinessService = () => {
  const list = async (window: BillingReadinessWindow): Promise<BillingReadinessResponse> => {
    return ChiroUpAPI.get('api', '/billing-readiness', { queryParams: { window } });
  };

  const detail = async (
    clinicId: number,
    window: BillingReadinessWindow
  ): Promise<BillingReadinessDetail> => {
    return ChiroUpAPI.get('api', `/billing-readiness/${clinicId}`, { queryParams: { window } });
  };

  return { list, detail };
};

export default billingReadinessService();
